import { render, staticRenderFns } from "./DeleteConfirmationDialog.vue?vue&type=template&id=23b851f8&"
import script from "./DeleteConfirmationDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteConfirmationDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports